import { render, staticRenderFns } from "./alertViewer.vue?vue&type=template&id=cc5c2b12&"
import script from "./alertViewer.vue?vue&type=script&lang=js&"
export * from "./alertViewer.vue?vue&type=script&lang=js&"
import style0 from "./alertViewer.vue?vue&type=style&index=0&id=cc5c2b12&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports